module.exports = __webpack_public_path__ + "img/eg12.1759dca0.png";